(function () {
    /* LEAVING (2026-10-09). A head guard has already replaced this page with the other skin
       (window.wcLeaving). The parser keeps running until that navigation commits, and this
       deferred file can execute in the gap — where the line below would overwrite a volunteer's
       saved wc_mode='weird' with 'plain' on a page they were never going to see. */
    if (window.wcLeaving) return;
    /* Snippet renders at end of body; the banner belongs above everything. */
    var banner = document.getElementById('wc-mode-banner');
    if (banner) document.body.insertBefore(banner, document.body.firstChild);

    /* Peek-and-tuck lives in snippets/wc-peek.liquid — one implementation, both skins. */

    /* "YOU ARE ON THE PLAIN STORE, SO PLAIN IS YOUR PREFERENCE" — true for everyone except
       the one group this must not touch. A visitor the head script ASSIGNED to the parody
       can still arrive on a plain rendering without pressing anything: a shared
       ?view=plain link, or one of the plain-only twins (/pages/refer-plain and friends).
       Overwriting here would end their assignment on a page load, and a holdout that leaks
       out through ordinary browsing measures nothing — the assigned column would keep its
       label and lose its people. Their stamp survives, so the next eligible link puts them
       back where the die put them.

       AND THE LINK DOOR (2026-09-14). theme.exhibit.liquid stamps a first-time arrival on one
       of CHET's ?view=weird links wc_mode_src='link' — a visitor he sent, not one the die or a
       button placed. They reach a plain rendering the same way an assigned one does (a twin, a
       shared ?view=plain link) and for them the overwrite was worse: it ended the visit he
       started on the second page. Kept for the same reason and by the same test; this file is
       the stamp's reader, so the value is not a flag without one. Everyone else is unchanged:
       a volunteer ('self') who lands here is still read as choosing plain, as since 08-29. */
    try {
      var src = localStorage.getItem('wc_mode_src');
      var keep = localStorage.getItem('wc_mode') === 'weird' &&
                 (src === 'assigned' || src === 'link');
      if (!keep) localStorage.setItem('wc_mode', 'plain');
    } catch (e) {}

    /* Arrival from a containment (weird -> plain): the polite fade. */
    try {
      if (sessionStorage.getItem('wc_fx') === 'contained') {
        sessionStorage.removeItem('wc_fx');
        document.documentElement.classList.add('wcm-calmin');
        setTimeout(function(){ document.documentElement.classList.remove('wcm-calmin'); }, 700);
      }
    } catch (e) {}

    var R = window.WC_ROUTES;

    /* THE ARRIVAL LINE. If we got here from a page whose url had to change under the
       visitor, say so in one row under the banner — what they were on, what this is, and the
       way back. Rendered before the button lookup below, which returns early on layouts that
       have no banner button. */
    if (R) { try { R.showNote(banner, 'plain'); } catch (e) {} }

    /* The rendered storefront owns its links. Browser assignment/history no longer decides
       whether a bare product card leaves this safe page for the parody. */
    if (R && R.bindViewLinks) R.bindViewLinks('plain');

    /* =================================================================
       THE BREACH — ten routines, one picked at random, and a harness
       whose only real job is that the visitor always lands on the weird
       site. See the registry note in the header comment.
       ================================================================= */
    var htmlEl = document.documentElement;
    var fxEl = document.getElementById('wcm-fx');
    /* THE FOOTER DOOR IS A RELEASE BUTTON TOO (2026-08-29). The plain banner is gone, so
       #pl-weird-door is the ONLY way from the safe site into the parody — and this block used
       to return here, which is why the ten routines silently stopped playing on that side.
       Binding to the door instead gives it the same theatre the banner had. The flag tells
       theme.plain.liquid's own capture-phase handler to stand down: without it that handler
       navigates immediately and nothing has time to play. If this file fails to load the flag
       is never set, the handler keeps its original behaviour, and the door still works —
       plainly, which is the right way for this to degrade. */
    var btn = document.getElementById('wc-mode-release') || document.getElementById('pl-weird-door');
    if (!btn) return;
    if (btn.id === 'pl-weird-door') btn.dataset.wcmTheatre = '1';

    /* --- the helper API handed to every routine ------------------- */
    var timers = [], tickers = [], snap = null, watchdog = 0, gone = false;

    function track(id) { timers.push(id); return id; }
    var FX = {
      /* schedule work; every callback is isolated so one throw cannot cost the rest */
      at: function (ms, fn) { track(setTimeout(function () { try { fn(); } catch (e) {} }, ms)); return FX; },
      q: function (sel) { return fxEl.querySelector(sel); },
      /* raise the overlay */
      on: function (ms, extra) {
        return FX.at(ms || 0, function () { fxEl.classList.add('on'); if (extra) fxEl.classList.add(extra); });
      },
      /* show a layer, optionally for a fixed window. HARD CUT: class on, class off. */
      show: function (sel, at, ms, mod) {
        FX.at(at, function () { var e = FX.q(sel); if (e) { if (mod) e.classList.add(mod); e.classList.add('go'); } });
        if (ms) FX.at(at + ms, function () { var e = FX.q(sel); if (e) { e.classList.remove('go'); if (mod) e.classList.remove(mod); } });
        return FX;
      },
      hide: function (sel, at) { return FX.at(at, function () { var e = FX.q(sel); if (e) e.classList.remove('go'); }); },
      /* a Chet splice. Enforced 70-110ms, hard cut, no fade — the timing that works.
         The TREATMENT class ('lo', 'rev') lands 60ms EARLY, which is invisible — the layer
         is still opacity:0 — and is the difference between a crisp cut and a smear: changing
         a filter on the frame at the same instant it becomes visible dirties the layer and
         forces its blur(34px) backdrop to re-rasterise inside the 70-110ms window. Ahead of
         time it costs nothing. No two splices share an element within 60ms, so the early
         class can never bleed into another cut. */
      splice: function (sel, at, ms, mod) {
        ms = Math.max(70, Math.min(110, ms || 90));
        if (mod) FX.at(Math.max(0, at - 60), function () { var e = FX.q(sel); if (e) e.classList.add(mod); });
        FX.at(at, function () { var e = FX.q(sel); if (e) e.classList.add('go'); });
        FX.at(at + ms, function () {
          var e = FX.q(sel);
          if (e) { e.classList.remove('go'); if (mod) e.classList.remove(mod); }
        });
        return FX;
      },
      /* an html.wcm-* class for a window of time */
      cls: function (name, at, ms) {
        FX.at(at, function () { htmlEl.classList.add(name); });
        if (ms) FX.at(at + ms, function () { htmlEl.classList.remove(name); });
        return FX;
      },
      /* a repeating tick (only the terminal needs one); cleared by teardown */
      every: function (ms, fn) { var id = setInterval(function () { try { fn(); } catch (e) {} }, ms); tickers.push(id); return id; },
      /* THE LAST THING SEEN. Every routine ends here instead of on its own flash, and the
         closer is what decides how long the exit takes — so done() is scheduled from the
         closer's own length and no routine has to know. A name that is not in CLOSERS, or a
         closer that throws, still lands on the white blowout and still calls done(). */
      close: function (name, at, done) {
        var ms = 240;
        try { ms = (CLOSERS[name] || CLOSERS.blowout)(FX, at) || 240; } catch (e) {}
        return FX.at(at + ms, done);
      }
    };

    /* --- THE CLOSERS ----------------------------------------------
       Nine of the ten routines used to end identically: .wcm-flash, then done() ~230ms
       later. The middles were all different and the exits were all the same, which is the
       half you remember. Each returns how long it needs after `at`; the assignment is in
       the registry below, matched to the routine that earns it. */
    var CLOSERS = {
      /* the original: everything burns out to white */
      blowout: function (fx, at) { fx.show('.wcm-flash', at); return 240; },
      /* the far side of the glass pours through the hole he tore. Replaced `zoomblur`, which
         terminated on .wcm-flash — the same white frame routines 0 and 7 end on — with its
         one distinguishing 170ms spent before the flash even started. That took the file to
         three of ten ending on the identical frame, which is the thing the closers exist to
         prevent. Deleting it also retired html.wcm-zoom, a 340ms blur(0->13px) on the whole
         page and the single most expensive thing here; nothing else called it. */
      throughglass: function (fx, at) { fx.show('.wcm-void', at); return 330; },
      /* one frame held dead still, then nothing — a hard lock */
      freeze: function (fx, at) { fx.cls('wcm-freeze', at, 320); fx.show('.wcm-cut', at + 180); return 270; },
      /* the picture goes negative and blows out black: under html.wcm-invert the white
         flash IS black, which is the whole trick and costs one extra class */
      negflash: function (fx, at) { fx.cls('wcm-invert', at, 320); fx.show('.wcm-flash', at + 70); return 290; },
      /* four panels close on the centre */
      shutter: function (fx, at) {
        fx.show('.wcm-pan.pt', at); fx.show('.wcm-pan.pb', at);
        fx.show('.wcm-pan.pl', at); fx.show('.wcm-pan.pr', at); return 290;
      },
      /* one panel wipes across the frame */
      curtain: function (fx, at) { fx.show('.wcm-pan.pl', at, 0, 'wide'); return 290; },
      /* the tube collapses to a line and then a dot */
      crush: function (fx, at) { fx.cls('wcm-crush', at, 360); return 300; },
      /* black, and one scanline folding up after it — a session dropping */
      blackcut: function (fx, at) { fx.show('.wcm-cut', at); fx.show('.wcm-line', at + 20); return 300; },
      /* the whole picture is pulled out of the top of the frame. This used to be
         html.wcm-eject — translateY(-114%) on <body>, i.e. -6057px on the real plain page,
         which threw the page AND the overlay off screen and showed the visitor nothing.
         The motion now lives on .wcm-tape inside the pinned overlay; see the percentage
         -transform block in the stylesheet for why that is the shape of the fix. */
      eject: function (fx, at) { fx.show('.wcm-tape', at); return 300; }
    };

    /* --- state that must not survive the press --------------------- */
    function snapshot() {
      snap = [];
      var all = [fxEl].concat([].slice.call(fxEl.querySelectorAll('*')));
      for (var i = 0; i < all.length; i++) {
        snap.push([all[i], all[i].getAttribute('class'), all[i].getAttribute('style')]);
      }
    }
    function restore() {
      if (!snap) return;
      for (var i = 0; i < snap.length; i++) {
        var el = snap[i][0], c = snap[i][1], s = snap[i][2];
        if (c === null) el.removeAttribute('class'); else el.setAttribute('class', c);
        if (s === null) el.removeAttribute('style'); else el.setAttribute('style', s);
      }
      snap = null;
    }
    function teardown() {
      try { clearTimeout(watchdog); } catch (e) {}
      for (var i = 0; i < timers.length; i++) { try { clearTimeout(timers[i]); } catch (e) {} }
      for (var j = 0; j < tickers.length; j++) { try { clearInterval(tickers[j]); } catch (e) {} }
      timers = []; tickers = [];
      /* every wcm-* class off <html>, including any a routine invented. If nothing else was
         on <html> the ATTRIBUTE goes too: leaving class="" behind is residue, and this
         snippet's whole claim is that a press leaves no trace. */
      try {
        var keep = [], cs = (htmlEl.getAttribute('class') || '').split(/\s+/);
        for (var k = 0; k < cs.length; k++) if (cs[k] && cs[k].indexOf('wcm-') !== 0) keep.push(cs[k]);
        if (keep.length) htmlEl.setAttribute('class', keep.join(' '));
        else htmlEl.removeAttribute('class');
      } catch (e) {}
      try { var t = fxEl.querySelector('.wcm-termtext'); if (t) t.textContent = ''; } catch (e) {}
      /* the shards are generated at press time, so they are not in the snapshot restore()
         works from — they have to be removed by name or they outlive the press */
      try { var s = fxEl.querySelector('.wcm-shards'); if (s) s.textContent = ''; } catch (e) {}
      try { restore(); } catch (e) {}
    }
    /* THE BUTTON MUST ALWAYS COME BACK. There are two ways a visitor is left holding a dead
       "oh no." that no longer does anything, and neither is exotic:
         · a bfcache back-navigation restores the disabled button (and possibly a class on
           <html>) from the moment of the press;
         · the visitor presses, then STOPS the load — hits Escape, kills a slow request, goes
           offline. No pagehide, no pageshow, no navigation: the page just sits there with a
           disabled button and the feature dead until a manual reload.
       One revive() for both. It is deliberately not clever: put everything back exactly as it
       was before the press, including `gone`, so the next press is a normal first press. */
    var BTN_LABEL = btn.textContent;
    function revive() {
      gone = false;
      try { teardown(); } catch (e) {}
      btn.textContent = BTN_LABEL;
      btn.disabled = false;
    }
    var reviveT = 0;
    window.addEventListener('pageshow', function (e) { if (e.persisted) revive(); });
    /* A navigation that is merely SLOW is not a navigation that failed. pagehide fires the
       moment this document is actually leaving, so a successful-but-slow load cancels the
       recovery instead of flashing "release him →" back at someone who is already on their
       way out. A stopped load never fires it, which is exactly the case being recovered. */
    window.addEventListener('pagehide', function () { try { clearTimeout(reviveT); } catch (e) {} });

    /* THE OVERLAY IS MEASURED, NOT ASSUMED. arm() pins #wcm-fx to the viewport in pixels
       (see the containing-block note in the header) and then measures it, because two things
       downstream need real boxes: the crack origins have to land on the fingertips, and the
       fracture has to be generated in real viewport pixels or it comes out aspect-stretched.
       The overlay is display:none at rest — deliberately, so the splice assets are not
       fetched until intent (see warm()) — so measuring means flipping it to display:block
       for the length of this function with visibility:hidden over it. No frame is produced
       in between, so nothing flashes; the images this triggers are the ones warm() has
       already started on hover/focus/pointerdown, and it is press time anyway. */
    var FXW = 0, FXH = 0;
    function arm() {
      /* THE SCROLL HAS TO BE A JUMP, NOT A SCROLL. theme.plain.liquid sets
         html{scroll-behavior:smooth}, which silently turns this into an ANIMATION: measured
         from scrollY 2600 on the 5313px plain page, the scroll was still at 2600 when the
         routine started, so the overlay sat at top -2615 and fxVisible was false for the
         whole press — the visitor saw the effects happen 2600px above them. The inline style
         beats the stylesheet everywhere; behavior:'instant' covers engines that honour it. */
      if (window.pageYOffset || window.pageXOffset) {
        var sb = htmlEl.style.scrollBehavior;
        htmlEl.style.scrollBehavior = 'auto';
        try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }
        catch (e) { window.scrollTo(0, 0); }
        htmlEl.style.scrollBehavior = sb;
      }
      var w = htmlEl.clientWidth, h = htmlEl.clientHeight;
      fxEl.style.left = '-12px'; fxEl.style.top = '-12px';
      fxEl.style.width = (w + 24) + 'px'; fxEl.style.height = (h + 24) + 'px';
      FXW = w + 24; FXH = h + 24;

      var wasOn = fxEl.classList.contains('on'), prevVis = fxEl.style.visibility;
      fxEl.style.visibility = 'hidden';
      fxEl.classList.add('on');
      try {
        /* THE CRACK FIELD IS AUTHORED IN A 1000-WIDE SPACE and drawn with
           preserveAspectRatio="none", which on a 375x812 phone stretched it 3.6:1 and turned
           a shatter into a row of vertical branches. Retune the viewBox to the real aspect so
           the mapping is uniform (and circles stay circles), then put each cluster's origin
           exactly under the fingertip it belongs to: cause and effect, or the eye does not
           buy it. --dx/--dy feed one CSS transform that carries both the placement and the
           growth — see the note on .wcm-cracks .cl. */
        var cr = fxEl.querySelector('.wcm-cracks');
        if (cr) {
          var H = Math.max(200, Math.round(1000 * FXH / FXW));
          cr.setAttribute('viewBox', '0 0 1000 ' + H);
          var fr = fxEl.getBoundingClientRect();
          /* The middle fingertip in the hand's own 200x300 space. The hand box is 2:3 and
             preserveAspectRatio is "meet", so there is no letterboxing and this is a plain
             proportion of the element's rect — right hand mirrored by its scaleX(-1). */
          var TIPX = 166 / 200, TIPY = 118 / 300;
          [['l', 130, false], ['r', 870, true]].forEach(function (spec) {
            var hand = fxEl.querySelector('.wcm-hand.' + spec[0]);
            var cells = fxEl.querySelectorAll('.wcm-cracks .c' + spec[0]);
            if (!hand || !cells.length || !fr.width || !fr.height) return;
            var hr = hand.getBoundingClientRect();
            if (!hr.width) return;
            var x = spec[2] ? (hr.right - TIPX * hr.width) : (hr.left + TIPX * hr.width);
            var y = hr.top + TIPY * hr.height;
            var dx = (x - fr.left) / fr.width * 1000 - spec[1];
            var dy = (y - fr.top) / fr.height * H - 300;
            for (var i = 0; i < cells.length; i++) {
              cells[i].style.setProperty('--dx', dx.toFixed(1) + 'px');
              cells[i].style.setProperty('--dy', dy.toFixed(1) + 'px');
            }
          });
        }
      } catch (e) {}
      if (!wasOn) fxEl.classList.remove('on');
      fxEl.style.visibility = prevVis;
    }

    /* THE PANE IS GLASS, NOT TILES. A radial fracture from one impact point, generated in
       viewport pixels so it is never stretched, clipped to the frame so no piece has a box
       bigger than the screen, and written as percentages of each piece's own box — twenty
       small composited layers rather than twenty full-screen ones. Two pieces are left out
       on purpose: a pane with holes already in it reads as glass instead of a grid. Rebuilt
       every press (the pattern is different each time) and emptied by teardown. */
    var RING = !!(window.CSS && CSS.supports && CSS.supports('clip-path', 'polygon(evenodd, 0% 0%, 100% 0%, 0% 100%)'));
    function clipRect(pts, W, H) {
      var edges = [[1, 0, 0], [-1, 0, W], [0, 1, 0], [0, -1, H]], e, i, out;
      for (e = 0; e < 4; e++) {
        var a = edges[e][0], b = edges[e][1], c = edges[e][2];
        out = [];
        for (i = 0; i < pts.length; i++) {
          var p = pts[i], q = pts[(i + 1) % pts.length];
          var dp = a * p[0] + b * p[1] + c, dq = a * q[0] + b * q[1] + c;
          if (dp >= 0) out.push(p);
          if ((dp >= 0) !== (dq >= 0)) {
            var t = dp / (dp - dq);
            out.push([p[0] + (q[0] - p[0]) * t, p[1] + (q[1] - p[1]) * t]);
          }
        }
        pts = out;
        if (pts.length < 3) return [];
      }
      return pts;
    }
    function shards() {
      var host = fxEl.querySelector('.wcm-shards');
      if (!host) return;
      host.textContent = '';
      var W = FXW, H = FXH, i, k;
      if (!(W > 0 && H > 0)) return;
      var cx = W * (.34 + Math.random() * .32), cy = H * (.3 + Math.random() * .32);
      var cn = [[0, 0], [W, 0], [W, H], [0, H]], D = 0;
      for (i = 0; i < 4; i++) {
        var ax = cn[i][0] - cx, ay = cn[i][1] - cy;
        D = Math.max(D, Math.sqrt(ax * ax + ay * ay));
      }
      /* the outer ring has to clear every corner, hence /cos(pi/SP) plus a margin */
      var SP = 7, BASE = [.22, .55, 1.3], JIT = [.34, .22, .08], ang = [], rad = [[], [], []];
      for (i = 0; i < SP; i++) {
        ang.push(i * 2 * Math.PI / SP + (Math.random() - .5) * .5);
        for (k = 0; k < 3; k++) rad[k].push(D * BASE[k] * (1 + (Math.random() - .5) * JIT[k]));
      }
      function P(k, i) { var a = ang[i % SP], r = rad[k][i % SP]; return [cx + Math.cos(a) * r, cy + Math.sin(a) * r]; }
      var cells = [];
      for (i = 0; i < SP; i++) {
        cells.push([[cx, cy], P(0, i), P(0, i + 1)]);
        cells.push([P(0, i), P(1, i), P(1, i + 1), P(0, i + 1)]);
        cells.push([P(1, i), P(2, i), P(2, i + 1), P(1, i + 1)]);
      }
      var missA = Math.floor(Math.random() * cells.length), missB = (missA + 5 + Math.floor(Math.random() * 9)) % cells.length;
      var frag = document.createDocumentFragment(), made = 0;
      for (var c = 0; c < cells.length; c++) {
        if (c === missA || c === missB) continue;
        var pts = clipRect(cells[c], W, H);
        if (pts.length < 3) continue;
        var minx = 1e9, miny = 1e9, maxx = -1e9, maxy = -1e9, sx = 0, sy = 0, n = pts.length;
        for (i = 0; i < n; i++) {
          minx = Math.min(minx, pts[i][0]); maxx = Math.max(maxx, pts[i][0]);
          miny = Math.min(miny, pts[i][1]); maxy = Math.max(maxy, pts[i][1]);
          sx += pts[i][0]; sy += pts[i][1];
        }
        var bw = maxx - minx, bh = maxy - miny;
        if (bw < 8 || bh < 8) continue;
        sx /= n; sy /= n;
        var outer = [], inner = [];
        for (i = 0; i < n; i++) {
          var px = pts[i][0], py = pts[i][1];
          outer.push(((px - minx) / bw * 100).toFixed(2) + '% ' + ((py - miny) / bh * 100).toFixed(2) + '%');
          /* the inner ring is a fixed 2px in from every edge, so the specular rim is the
             same weight on a big piece and a small one */
          var vx = px - sx, vy = py - sy, L = Math.sqrt(vx * vx + vy * vy) || 1, s = Math.max(0, 1 - 2.6 / L);
          inner.push(((sx + vx * s - minx) / bw * 100).toFixed(2) + '% ' + ((sy + vy * s - miny) / bh * 100).toFixed(2) + '%');
        }
        var poly = 'polygon(' + outer.join(',') + ')';
        var dsx = sx - cx, dsy = sy - cy, dist = Math.sqrt(dsx * dsx + dsy * dsy);
        var d = document.createElement('div');
        d.className = 'wcm-shard';
        d.style.cssText = 'left:' + (minx / W * 100).toFixed(3) + '%;top:' + (miny / H * 100).toFixed(3) + '%;' +
          'width:' + (bw / W * 100).toFixed(3) + '%;height:' + (bh / H * 100).toFixed(3) + '%;' +
          '-webkit-clip-path:' + poly + ';clip-path:' + poly + ';' +
          '--a:' + Math.round(Math.random() * 360) + 'deg;' +
          '--r:' + (Math.random() * 70 - 35).toFixed(1) + 'deg;' +
          '--tx:' + (Math.random() * W * .12 - W * .06).toFixed(0) + 'px;' +
          '--d:' + Math.round(dist / (D || 1) * 250 + Math.random() * 90) + 'ms';
        if (RING) {
          var ring = 'polygon(evenodd,' + outer.join(',') + ',' + inner.join(',') + ')';
          var edge = document.createElement('i');
          edge.style.cssText = '-webkit-clip-path:' + ring + ';clip-path:' + ring;
          d.appendChild(edge);
        }
        /* a few of them catch the light as they turn — not all of them, or it is a disco */
        if (made % 4 === 1) d.appendChild(document.createElement('u'));
        frag.appendChild(d);
        made++;
      }
      host.appendChild(frag);
    }

    /* The splice assets live inside a display:none overlay, so nothing is fetched until the
       overlay is shown — which is 300ms too late for the first cut. Warm them on intent
       instead: hover, focus or the pointerdown that precedes the click. Visitors who never
       reach for the button never pay for them. */
    var warmed = false;
    function warm() {
      if (warmed) return; warmed = true;
      var srcs = [], nodes = fxEl.querySelectorAll('[style*="background-image"]');
      for (var i = 0; i < nodes.length; i++) {
        var m = /url\(['"]?([^'")]+)/.exec(nodes[i].getAttribute('style') || '');
        if (m && srcs.indexOf(m[1]) < 0) srcs.push(m[1]);
      }
      for (var j = 0; j < srcs.length; j++) { var im = new Image(); im.src = srcs[j]; }
    }
    btn.addEventListener('pointerenter', warm);
    btn.addEventListener('pointerdown', warm);
    btn.addEventListener('focus', warm);

    /* =================================================================
       REAL RENDERS (2026-08-18). Every routine owns a unique set of
       photoreal frames — horror played straight, a mustachioed man in
       aviators doing a monster's job. the-approach is five frames of ONE
       continuous scene: far → mid-run → lunging → palms on the glass →
       fingers through the tear.

       THE TWO RULES THIS BLOCK LIVES UNDER:
         · IMAGES NEVER DELAY THE NAVIGATION. Sets preload lazily, AFTER
           window load, one set at a time; a press only uses a set whose
           every frame is already decoded in cache. Anything else runs
           the splice theatre exactly as it ran yesterday. No routine
           waits, no frame is fetched on the press path.
         · NOTHING PERSISTS. applyFrames() runs after snapshot(), so the
           .real/.apr classes, the --af vars and every inline background
           swap are all reverted by restore() with the rest of the press.
       ================================================================= */
    /* The frame table is the only Liquid in this file — it interpolates asset_url thirty-two
       times — so the snippet emits it inline and this reads it off window. Everything else
       lives in assets/wc-mode.js, where Shopify's CDN can cache it for a year instead of
       re-sending 46KB on every page view. */
    var WCM_FRAMES = window.WCM_FRAMES || {};
    /* A set is usable only when every frame in it has LOADED — half a set would mean one
       crisp render hard-cutting to a stale splice mid-routine, which reads as a bug, not a
       style. Loaded-flag granularity is the set, and a failed frame poisons only its set. */
    var WCM_READY = {};
    function preloadFrames() {
      /* Reduced-motion visitors never see a frame (the press navigates before selection);
         Save-Data visitors should not spend ~2MB on an interstitial. Both still get the
         full working toggle and the beacon — this skips bytes, never behaviour. */
      try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
      try { if (navigator.connection && navigator.connection.saveData) return; } catch (e) {}
      var names = [], n;
      for (n in WCM_FRAMES) if (WCM_FRAMES.hasOwnProperty(n) && n !== 'the-approach') names.push(n);
      /* Fisher-Yates, then the flagship first: on a short first visit the one set most
         worth having warm is the owner's sequence; the shuffle behind it means repeat
         visitors on slow lines don't all warm the same subset in the same order. */
      for (var i = names.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1)), t = names[i]; names[i] = names[j]; names[j] = t;
      }
      names.unshift('the-approach');
      var qi = 0;
      (function nextSet() {
        if (qi >= names.length) return;
        var name = names[qi++], list = WCM_FRAMES[name], left = list.length, ok = true;
        for (var k = 0; k < list.length; k++) (function (src) {
          var im = new Image();
          im.onload = function () { if (--left === 0) { WCM_READY[name] = ok; nextSet(); } };
          im.onerror = function () { ok = false; if (--left === 0) { WCM_READY[name] = ok; nextSet(); } };
          im.src = src;
        })(list[k]);
      })();
    }
    /* AFTER load, plus a beat — the plain page's own images win every contest for the pipe.
       The 'load' event may already be behind us (this snippet renders at end of body but a
       bfcache restore re-runs nothing), so both arms are covered. */
    if (document.readyState === 'complete') setTimeout(preloadFrames, 1200);
    else window.addEventListener('load', function () { setTimeout(preloadFrames, 1200); });

    function wcmBg(el, url) { if (el) el.style.backgroundImage = 'url("' + url + '")'; }
    /* Dress the machinery in this routine's own renders, for THIS press only. Called after
       snapshot() and arm() — so restore() reverts everything here, and the crack retarget
       below can trust the measured overlay box. A set that is not warm is a silent no-op. */
    function applyFrames(name) {
      var f = WCM_FRAMES[name];
      if (!f || !WCM_READY[name]) return;
      fxEl.classList.add('real');
      if (name !== 'the-approach') {
        wcmBg(fxEl.querySelector('.wcm-chet.c1'), f[0]);
        wcmBg(fxEl.querySelector('.wcm-chet.c2'), f[1]);
        wcmBg(fxEl.querySelector('.wcm-chet.c3'), f[2]);
        return;
      }
      /* THE APPROACH. Stages 1-3 become full-bleed frames of the one continuous scene (CSS
         vars feed the .apr rules); the glass act composites frame 4 under the existing
         bezel/cracks/sheen; frame 5 — his fingers through the tear — hard-cuts in just
         before the tear animation, on a tracked timer teardown() clears like any other. The
         three splices become subliminal glimpses of him CLOSER than he currently is, which
         is what a splice inside an approach is for. */
      fxEl.classList.add('apr');
      fxEl.style.setProperty('--af1', 'url("' + f[0] + '")');
      fxEl.style.setProperty('--af2', 'url("' + f[1] + '")');
      fxEl.style.setProperty('--af3', 'url("' + f[2] + '")');
      wcmBg(fxEl.querySelector('.wcm-near'), f[3]);
      wcmBg(fxEl.querySelector('.wcm-chet.c1'), f[2]);
      wcmBg(fxEl.querySelector('.wcm-chet.c2'), f[3]);
      wcmBg(fxEl.querySelector('.wcm-chet.c3'), f[4]);
      FX.at(1400, function () { wcmBg(fxEl.querySelector('.wcm-near'), f[4]); });
      /* CRACKS UNDER THE RENDERED PALMS. arm() aimed the crack clusters at the SVG hands,
         which .apr hides — frame 4's palms sit at the left and right edges of the CONTAINED
         square, not the viewport edges. Same coordinate walk as arm(): overlay fraction into
         the retuned viewBox, minus each cluster's authored origin (130/870, y 300). If any
         measurement is missing the clusters keep arm()'s values — cracks in a slightly
         wrong place beat no cracks. */
      try {
        var cr = fxEl.querySelector('.wcm-cracks');
        var vb = cr && (cr.getAttribute('viewBox') || '').split(/\s+/);
        var H = vb && Number(vb[3]);
        if (cr && H && FXW > 0 && FXH > 0) {
          var box = Math.min(.86 * FXH, .92 * FXW, 900);
          var yv = (FXH / 2) / FXH * H - 300;
          [['l', .5 - (box / FXW) * .42, 130], ['r', .5 + (box / FXW) * .42, 870]].forEach(function (s) {
            var cells = fxEl.querySelectorAll('.wcm-cracks .c' + s[0]);
            for (var i = 0; i < cells.length; i++) {
              cells[i].style.setProperty('--dx', (s[1] * 1000 - s[2]).toFixed(1) + 'px');
              cells[i].style.setProperty('--dy', yv.toFixed(1) + 'px');
            }
          });
        }
      } catch (e) {}
    }

    /* =================================================================
       THE REGISTRY. Ten routines, run(fx, done). Each calls done() when
       it is time to navigate; the harness does the rest.

       Every routine but the first ends on fx.close(), and the closers are
       assigned so that no two routines you are likely to see near each
       other exit the same way. The durations below are the REAL scheduled
       total — fx.close(at) plus what that closer returns — and they are
       checked against the schedule, not estimated; a stale number in a
       file with this much commentary is a trap for the next reader.
       RE-DERIVE THIS TABLE, DO NOT TRUST IT. Every total is `fx.close(name, at, done)`'s
       `at` plus what CLOSERS[name] returns; routine 0 is the exception and states its own
       `fx.at(ms, done)`. That is two greps and an addition, and it is the only reason these
       numbers are allowed to sit in a comment at all. They were last re-derived from the
       schedule on 2026-08-17 and every row below matched.
         idx routine             closer        ends on          total
         0   containment-breach  (inline)      white            1400ms
         1   the-approach        throughglass  violet swallow   1890ms
         2   cartridge-blowout   freeze        black            1420ms
         3   tracking-error      negflash      inverted white   1550ms
         4   pane-collapse       shutter       black panels     1470ms
         5   degauss-thunk       crush         collapsed page   1300ms
         6   no-signal           curtain       black wipe       1480ms
         7   the-melt            blowout       white            1690ms
         8   rewind-scrub        eject         black, seam out  1420ms
         9   hostile-terminal    blackcut      black + scanline 1620ms
       Two of the ten now end on the white blowout (0 and 7, both on
       purpose); it was three, because the-approach spent its whole grab
       -and-tear payoff and then finished on the house flash.
       Longest is 1890ms, and the watchdog is 2200ms.
       ================================================================= */
    var ROUTINES = [
      /* 0 — CONTAINMENT BREACH (the original, unchanged: shake, CRT tear, two inversion
         pops, lightning, white-out). 1400ms. */
      { n: 'containment-breach', run: function (fx, done) {
        fx.cls('wcm-quake', 0);
        fx.on(250, 'bars');
        fx.show('.wcm-static', 250);
        fx.splice('.wcm-chet.c1', 430, 80);
        fx.cls('wcm-invert', 520, 80);
        fx.show('.wcm-bolt', 650);
        fx.splice('.wcm-chet.c2', 780, 90);
        fx.cls('wcm-invert', 900, 90);
        fx.splice('.wcm-chet.c3', 1050, 90);
        fx.show('.wcm-flash', 1160);
        fx.at(1400, done);
      }},

      /* 1 — THE APPROACH (Josh's). He is a long way back in the dark. Every burst of screen
         chaos leaves him closer, until his hands are hooked over the edges of your monitor
         and the glass gives. Stages are hard cuts too — the distance is the story, so each
         stage holds ~200ms, with proper 90ms splices inside the bursts. The glass act is the
         payload and it was being rushed: the hands land, they press (the .go on the glass
         drives that), and only then does the crack open under the fingertips, hold at full
         size, and tear. 1890ms. */
      { n: 'the-approach', run: function (fx, done) {
        fx.on(0);
        fx.show('.wcm-scene', 0);
        fx.show('.wcm-far', 100, 150, 's1');           // tiny, far back, out of focus
        fx.cls('wcm-quake', 250);
        fx.at(250, function () { fxEl.classList.add('bars'); });
        fx.show('.wcm-static', 250, 120);
        fx.splice('.wcm-chet.c1', 280, 90);
        fx.show('.wcm-far', 400, 200, 's2');           // closer
        fx.at(610, function () { fxEl.classList.remove('bars'); });
        fx.cls('wcm-invert', 620, 80);
        fx.splice('.wcm-chet.c2', 670, 90);
        fx.show('.wcm-far', 790, 200, 's3');           // closer still, in focus now
        fx.show('.wcm-static', 990, 90);
        fx.cls('wcm-invert', 1000, 70);
        fx.at(1030, function () { htmlEl.classList.remove('wcm-quake'); });  // glass must not shake
        fx.show('.wcm-glass', 1060);                   // at the monitor: hands on the edges
        fx.at(1110, function () { var g = fx.q('.wcm-glass'); if (g) g.classList.add('crack'); });
        fx.at(1460, function () { var g = fx.q('.wcm-glass'); if (g) g.classList.add('tear'); });
        /* through the hole he just made, not a generic flash: the closer starts 100ms into
           the 300ms tear, so the violet arrives while the glass is still coming apart. */
        fx.close('throughglass', 1560, done);
      }},

      /* 2 — CARTRIDGE BLOWOUT. The site drops to sixth-generation console: texture budget
         gone, bilinear smear, distance fog, unsnapped vertices. The resolution halves on a
         hard cut halfway through. 1420ms. */
      { n: 'cartridge-blowout', run: function (fx, done) {
        fx.on(0);
        fx.cls('wcm-n64blur', 40, 420);                // the one full-viewport blur: 2.2px, 420ms
        fx.cls('wcm-n64', 40, 1120);
        fx.show('.wcm-pix.p1', 40, 200);
        fx.cls('wcm-vtx', 90, 950);
        fx.show('.wcm-pix.p2', 240);                   // hard cut: the resolution halves
        fx.show('.wcm-fog', 200);
        fx.splice('.wcm-chet.c1', 430, 90, 'lo');
        fx.hide('.wcm-pix.p2', 620);
        fx.show('.wcm-pix.p1', 620);
        fx.splice('.wcm-chet.c3', 700, 90, 'lo');
        fx.show('.wcm-pix.p2', 900, 120);
        fx.splice('.wcm-chet.c2', 1000, 80, 'lo');
        fx.close('freeze', 1150, done);
      }},

      /* 3 — TRACKING ERROR. The tape is bad: one sync bar rolls up the picture forever, the
         vertical hold slips in hard steps, chroma separates into a cyan and a magenta
         sheet that will not line up again. 1550ms. */
      { n: 'tracking-error', run: function (fx, done) {
        fx.on(0);
        fx.show('.wcm-roll', 0);
        fx.cls('wcm-vhold', 80, 480);
        fx.show('.wcm-chroma.cy', 200, 90);
        fx.show('.wcm-chroma.mg', 260, 140);
        fx.splice('.wcm-chet.c2', 340, 90);
        fx.show('.wcm-static', 480, 120);
        fx.splice('.wcm-chet.c1', 640, 80);
        fx.cls('wcm-vhold', 780, 320);
        fx.show('.wcm-chroma.cy', 900, 180);
        fx.show('.wcm-static', 1050, 160);
        fx.splice('.wcm-chet.c3', 1080, 90);
        fx.hide('.wcm-roll', 1220);
        fx.close('negflash', 1260, done);
      }},

      /* 4 — PANE COLLAPSE. A sheet of glass breaks off the FRONT of the page and falls out
         of the bottom of the frame in a stagger, and the site is still there behind it the
         whole way down. It used to drop a grid of opaque black rectangles over a dark scene,
         which is why it read as the lights going out and nothing else; shards() and the
         note above it are the fix. The scene is gone from this routine on purpose — the
         page must stay lit, or there is nothing for the glass to be in front of. 1470ms. */
      { n: 'pane-collapse', run: function (fx, done) {
        fx.on(0);
        fx.cls('wcm-quake', 0, 260);                   // the impact
        fx.show('.wcm-shards', 170);                   // hard cut: the front of the page is broken
        fx.splice('.wcm-chet.c1', 330, 90);
        fx.at(470, function () { var h = fx.q('.wcm-shards'); if (h) h.classList.add('fall'); });
        fx.splice('.wcm-chet.c2', 760, 90);
        fx.splice('.wcm-chet.c3', 1010, 80);
        fx.close('shutter', 1180, done);
      }},

      /* 5 — DEGAUSS THUNK. Somebody hit the button on the front of the tube: a rainbow
         bloom washes out from the centre, the geometry bows, and it settles wrong. 1300ms. */
      { n: 'degauss-thunk', run: function (fx, done) {
        fx.on(0);
        fx.show('.wcm-bloom', 30, 560);
        fx.cls('wcm-wob', 30, 620);
        fx.splice('.wcm-chet.c3', 130, 80);
        fx.cls('wcm-invert', 270, 60);
        fx.splice('.wcm-chet.c1', 390, 90);
        fx.show('.wcm-bloom', 640, 360);
        fx.cls('wcm-wob', 660, 330);                   // ends before the crush takes <body>
        fx.splice('.wcm-chet.c2', 860, 70);
        fx.close('crush', 1000, done);
      }},

      /* 6 — NO SIGNAL. The broadcast gives up and cuts to the test card, twice, with him
         in the gap between the cards. 1480ms. */
      { n: 'no-signal', run: function (fx, done) {
        fx.on(0);
        fx.show('.wcm-smpte', 60, 240);
        fx.show('.wcm-static', 300, 90);
        fx.splice('.wcm-chet.c1', 390, 90);
        fx.show('.wcm-smpte', 480, 280);
        fx.show('.wcm-nosig', 500, 560);
        fx.splice('.wcm-chet.c2', 780, 90);
        fx.show('.wcm-smpte', 880, 170, 'inv');
        fx.show('.wcm-static', 1060, 110);
        fx.splice('.wcm-chet.c3', 1080, 80);
        fx.close('curtain', 1190, done);
      }},

      /* 7 — THE MELT. The page sags out of true while something thick runs down over it.
         Both splices sit OUTSIDE the sag window on purpose: <body> is stretched 1.35x
         vertically and the overlay rides with it, which would crop him. 1690ms. */
      { n: 'the-melt', run: function (fx, done) {
        fx.on(0);
        fx.splice('.wcm-chet.c1', 70, 90);             // clean geometry, before the sag
        fx.cls('wcm-sag', 220, 900);
        fx.show('.wcm-ooze', 230);
        fx.show('.wcm-static', 620, 130);
        fx.show('.wcm-scene', 1080);                   // ooze has covered; sag snaps back hidden
        fx.hide('.wcm-ooze', 1120);
        fx.splice('.wcm-chet.c2', 1180, 90);           // clean geometry again
        fx.splice('.wcm-chet.c3', 1330, 80);
        fx.close('blowout', 1450, done);              // soft: a melt cannot end on a cut
      }},

      /* 8 — REWIND SCRUB. Somebody is spooling the site backwards: cold blue tint, hard
         positional stutter, streaks flying the wrong way, and he plays mirrored. 1420ms. */
      { n: 'rewind-scrub', run: function (fx, done) {
        fx.on(0);
        fx.show('.wcm-tint', 0, 900);
        fx.cls('wcm-rew', 40, 860);
        fx.show('.wcm-streak.k1', 40, 860); fx.show('.wcm-streak.k2', 40, 860); fx.show('.wcm-streak.k3', 40, 860);
        fx.show('.wcm-osd', 60, 860);
        fx.splice('.wcm-chet.c1', 300, 90, 'rev');
        fx.show('.wcm-static', 520, 100);
        fx.splice('.wcm-chet.c2', 620, 80, 'rev');
        fx.splice('.wcm-chet.c3', 780, 70, 'rev');
        fx.cls('wcm-invert', 980, 60);
        fx.close('eject', 1120, done);
      }},

      /* 9 — HOSTILE TERMINAL. Something types over the site, gets one honest line out, and
         is interrupted twice by the thing it is describing. 1620ms. */
      { n: 'hostile-terminal', run: function (fx, done) {
        var SCRIPT = '> wc_containment --release CHET\n> unlocking door ....... OK\n> HE IS ALREADY OUT';
        fx.on(0);
        fx.show('.wcm-term', 60);
        fx.at(80, function () {
          var pre = fx.q('.wcm-termtext');
          if (!pre) return;
          var i = 0, cur = document.createElement('span');
          cur.className = 'wcm-cur';
          fx.every(14, function () {
            if (i > SCRIPT.length) return;
            pre.textContent = SCRIPT.slice(0, i);
            pre.appendChild(cur);
            i++;
          });
        });
        fx.splice('.wcm-chet.c1', 480, 90);
        fx.splice('.wcm-chet.c2', 900, 90);
        fx.at(1180, function () { var t = fx.q('.wcm-term'); if (t) t.classList.add('bad'); });
        fx.splice('.wcm-chet.c3', 1230, 80);
        fx.close('blackcut', 1320, done);
      }}
    ];

    /* --- the press ------------------------------------------------- */
    btn.addEventListener('click', function () {
      /* THE DOOR, COUNTED. wcTrack sends its own beacon immediately, well before the
         navigation, so this does not depend on pagehide surviving `location.href` — and it
         does not depend on the pageview batch either, which is one-shot and may already have
         been spent by a tab switch. The function only EXISTS when wc-telemetry.js decided
         this visitor is countable (not DNT, not the theme editor, not a prerender, not the
         owner), so an excluded visitor is a no-op here with nothing to remember. */
      if (window.wcTrack) window.wcTrack('mode:release');
      /* CHOSEN, AND SAID SO. The beacon has already fired on the line above carrying whatever
         this visitor was BEFORE the press, which is the correct attribution for the act of
         switching; the stamp below describes them from here on. Written together with the
         mode and in the same guard, so a browser that cannot store one cannot store the
         other and no half-labelled visitor exists. */
      try {
        localStorage.setItem('wc_mode', 'weird');
        localStorage.setItem('wc_mode_src', 'self');
      } catch (e) {}

      /* RELEASE KEEPS YOUR PLACE TOO. Dropping ?view= is right for every page that exists at
         the same path in both stores, and wrong for the plain-only twins: releasing from
         /pages/refer-plain used to land back on /pages/refer-plain, which is still the plain
         page. The reverse table sends those to their parody counterpart and carries ?from= so
         the arrival explains the url change. */
      var dest;
      if (R) {
        dest = R.toWeird(location.pathname, location.search, location.hash).url;
      } else {
        var u = new URL(location.href);
        u.searchParams.delete('view');
        dest = u.pathname + u.search + u.hash;
      }
      var go = function () {
        if (gone) return;
        gone = true;
        try { teardown(); } catch (e) {}
        /* Set AFTER teardown so it is not one of the timers teardown just cleared, and before
           the navigation so it is armed whatever happens next. If the navigation lands, this
           timer dies with the document; if the visitor stops the load, it is the only thing
           left that can give them the button back. */
        try { reviveT = setTimeout(revive, 4000); } catch (e) {}
        location.href = dest;
      };

      /* ONE GUARD, BEFORE SELECTION. Reduced motion gets no routine at all. */
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return go();

      try { sessionStorage.setItem('wc_fx', 'breach'); } catch (e) {}
      this.textContent = 'oh no.';
      this.disabled = true;

      /* THE WATCHDOG IS THE CONTRACT. A routine that throws, an animation that never fires,
         a timer the browser drops while the tab is backgrounded — none of them can strand a
         visitor on the corporate site. Longest routine is 1890ms; this fires at 2200ms. */
      watchdog = setTimeout(go, 2200);

      try {
        /* snapshot BEFORE arm(), so the pinning styles arm() writes are themselves undone;
           shards AFTER it, because the fracture is generated from the measurements it takes */
        snapshot();
        arm();
        shards();
        var pick = ROUTINES[Math.floor(Math.random() * ROUTINES.length)];
        /* the routine's own renders, if — and only if — they are already warm; after
           snapshot() so the press still leaves nothing behind, after arm() so the crack
           retarget can trust FXW/FXH. A cold set means yesterday's theatre, seamlessly. */
        applyFrames(pick.n);
        pick.run(FX, go);
      } catch (e) {
        go();
      }
    });
  })();
